import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { hasError: boolean; message: string };

export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: "" };

  static getDerivedStateFromError(error: unknown): State {
    const message = error instanceof Error ? error.message : "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ";
    return { hasError: true, message };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("RouteErrorBoundary", error, info);
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-[45vh] items-center justify-center">
        <div className="w-full max-w-xl rounded-2xl border border-amber-200 bg-amber-50 p-5 text-sm text-amber-900 shadow-card">
          <p className="font-semibold">โหลดหน้าปัจจุบันไม่สำเร็จ</p>
          <p className="mt-2 leading-relaxed text-amber-800">
            มีข้อผิดพลาดขณะโหลดโค้ดของหน้านี้ (เช่นไฟล์ chunk ไม่ครบหรือแคชเก่า)
            ลองรีเฟรชหน้าอีกครั้ง หากยังไม่หายให้แจ้งทีมพร้อมเวลาที่พบปัญหา
          </p>
          <p className="mt-2 font-code text-xs text-amber-700">error: {this.state.message}</p>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-4 rounded-lg border border-amber-300 bg-amber-100 px-3 py-2 text-xs font-semibold text-amber-900 hover:bg-amber-200"
          >
            รีเฟรชหน้า
          </button>
        </div>
      </div>
    );
  }
}
